import { success } from '@/utils/alert'
import bus from '@/utils/eventBus'

export default {
  doAfterSave () {

  },
  clearForm () {
    this.invite = {
      document: null,
      state: null,
      name: null,
      email: null
    }
  },
  doSaveInvite () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }
    const registerProfessionalInvite = this.invite
    this.$http.post('v1/professional/companies/staffs/invite', registerProfessionalInvite)
    .then(({data}) => {
      // lipando campos
      this.clearForm()
      // Fechando modal
      this.$emit('close', data)
      success('Profissional incluído no Corpo Clínico. </br></br> Um Convite foi enviado para o email informado.')
    })
    .catch(({data, meta}) => {
      this.existProfessonal = true
      // Se caso ja existir um professional com os dados então activa o botão novamente para midifcação de dados
      bus.$emit('event-new-staff', {show: true})
      this.$emit('close', data)
    })
  },

  // Verificando se ja eiste profissional
  loadCheckProfessional: function () {
    if (this.invite.document != null && this.invite.state) {
      const registerProfessionalInvite = this.invite
      this.$http.post('v1/professional/companies/staffs/check', registerProfessionalInvite)
      .then(({data}) => {
        clearInterval(this.interval)
      })
      .catch(({data, meta}) => {
        clearInterval(this.interval)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/components/invite/resources/methods.js